import StartingProjectDisplay from '../../../StartingProjectDisplay/StartingProjectDisplay';
import { CollaborationStartingProjectImages } from '../../../StartingProjectDisplay/StartingProjectImages';
import { useViewContext } from '../../ViewContext';
import { useWorkEntityFieldQuery } from './WorkEntityField.generated';

interface WorkEntityFieldProps {
    workEntityValue: string;
    title?: string;
    description?: string | null;
}

export default function WorkEntityField(props: WorkEntityFieldProps) {
    const { isCollaborationMode } = useViewContext();
    const { data, error } = useWorkEntityFieldQuery({
        variables: {
            workId: props.workEntityValue,
        },
    });

    if (error) {
        throw error;
    }

    const images = data?.workEntityViews.views.map((view) => ({
        url: view._links.image.href,
        title: view._links.image.title,
    }));

    return isCollaborationMode ? (
        <CollaborationStartingProjectImages images={images} />
    ) : (
        <StartingProjectDisplay
            images={images}
            title={props.title}
            description={props.description}
        />
    );
}
